import { InspectionData } from "../../types/workOrder";
import axiosInstance from "./axiosInstance";

export const getWordOrdersAPI = async (token: string) => {
  const response = await axiosInstance.get("/WorkOrders/GetWorkOrders", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};


export const submitInspectionDataAPI = async ({
  token,
  inspectionData,
  workOrder_ID,
}: {
  token: string | null;
  inspectionData: InspectionData;
  workOrder_ID: number;
}): Promise<any> => {

  const response = await axiosInstance.put(`/WorkOrders/InspectionCompleted?workOrder_ID=${workOrder_ID}`, inspectionData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};
